import { queryBrandList } from "@/api/brand";
import { getBrandMetarialList } from "@/api/material";
import MediaPreview from "@/components/media-preview";
import PosterSwipe, { CustomEditData } from "@/components/poster-swiper";
import TopBar from "@/components/top-bar";
import Empty from "@/pages/imageSearch/components/Empty";
import { onShareAppMessageByBrandMaterial, sharePosterParams4H5Material } from "@/utils/actions";
import { useCommonContext } from "@/utils/context/common";
import useNavigation from "@/utils/useNavigate";
import { AIMaterialMediaModel } from "@akc/biz-api";
import { ImageURLUitls } from "@akc/foundation";
import { MaterialListCardComp, TrackDataContext } from "@akc/mx-taro-h5-components";
import { InfiniteScroll, List } from "antd-mobile";
import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import { useSearchParams } from "react-router-dom";
import SideBar from "../../components/side/index";
import styles from "./index.module.less";

const loadingPng =
  "https://akim-oss.aikucun.com/586c047ad6fdba65ce060e7f8b37a399d2fd1d9b_1729047640191_29.png";

interface BrandCardModel {
  brandId: string;
  brandName: string;
  brandLogo: string;
}

const BrandMaterial = () => {
  const { track } = useCommonContext();
  const initPagesConfig = {
    pageNo: 1,
    pageSize: 10,
    sortModel: 32,
    pageId: "H5_MaterialList",
    voConfig: {
      queryCollectionFlag: true,
    },
  };
  const [searchParams] = useSearchParams();
  const { navigate2Material } = useNavigation();
  const [brandId, setBrandId] = useState(searchParams.get("brandId") || "");
  const [loading, setLoading] = useState(false);
  const [hasMore, setHasMore] = useState(false);
  const [brandList, setBrandList] = useState<BrandCardModel[]>([] as BrandCardModel[]);
  const [firstLoading, setFirstLoading] = useState(true);
  const [materialList, setMaterialList] = useState([]);
  const [showPoster, setShowPoster] = useState(false);
  const [sharePosterData, setSharePosterData] = useState<any>({});
  const [customEditData, setCustomEditData] = useState<CustomEditData>({} as CustomEditData);
  const [pagesConfig, setPagesConfig] = useState(initPagesConfig);
  const previous_page_name = useMemo(() => {
    const temp = searchParams.get("previous_page_name");
    return temp ? decodeURIComponent(temp) : "";
  }, [searchParams]);
  const frontCodes: any = useRef([]);
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const { trackData: contextTrackData } = useContext(TrackDataContext);
  const [isPreviewVisible, setPreviewVisible] = useState(false);
  const [selectIndex, setSelectIndex] = useState<number>(0);
  const [materialListNew, setMaterialListNew] = React.useState<AIMaterialMediaModel[]>([]);

  const getQueryOpts = params => {
    const selectionProductType = searchParams.get("selectionProductType");
    const bodyIdListStr: string = searchParams.get("bodyIdList") || "";
    const brandIdsStr: string = searchParams.get("brandIds") || "";
    let bodyIdList: string[] = [];
    let brandIds: string[] = [];

    try {
      if (selectionProductType) {
        bodyIdList = bodyIdListStr ? decodeURIComponent(bodyIdListStr).split(",") : [];
        brandIds = brandIdsStr ? decodeURIComponent(brandIdsStr).split(",") : [];
      }
    } catch (e) {
      console.error(e);
    }

    if (!selectionProductType) {
      return params;
    }
    const opts: any = {
      pageId: "H5_MaterialList",
    };
    if (selectionProductType !== "BRAND") {
      opts.frontCodes = brandIds.map(e => ({
        type: 2,
        code: e,
      }));
    }
    if (params?.frontCodes || opts?.frontCodes) {
      opts.frontCodes = [...(params?.frontCodes || []), ...(opts?.frontCodes || [])];
      opts.frontCodes = opts.frontCodes.filter(
        (item, index, self) =>
          item.code && index === self.findIndex(t => t.type === item.type && t.code === item.code),
      );
    }
    return {
      ...params,
      ...opts,
    };
  };

  const getMaterialList = (refresh = false) => {
    let params = {
      ...pagesConfig,
      frontCodes: frontCodes.current,
    };
    if (refresh) {
      setMaterialList([]);
      params.pageNo = 1;
    }
    params = getQueryOpts(params);
    return getBrandMetarialList(params)
      .then(({ data }) => {
        const list = params.pageNo === 1 ? data.result : materialList.concat(data.result);

        setMaterialList(list);
        setHasMore(data.hasNext);
        setPagesConfig({
          ...pagesConfig,
          pageNo: params.pageNo + 1,
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };
  const loadMore = async () => {
    if (hasMore && !loading) {
      setLoading(true);
      getMaterialList();
    }
  };
  const getServerTime = () => {
    return new Date().getTime();
  };
  const onClosePoster = () => {
    setShowPoster(false);
  };
  const onForwardAction = async item => {
    setSharePosterData(
      await sharePosterParams4H5Material({
        materialId: item.materialNo,
        activitySpuId: frontCodes.current[0].code || "",
      }),
    );
    setCustomEditData({
      activitySpuId: item.activitySpuId,
      activityId: item.activityId,
      selectSkuId: item.selectSkuId,
      materialNo: item.materialNo,
    });
    setShowPoster(true);
  };
  const toMaterialDetailPage = item => {
    const { type, materialNo } = item;
    navigate2Material(type, materialNo, frontCodes.current[0].code || "");
  };

  useEffect(() => {
    document.title = "品牌素材";
    onShareAppMessageByBrandMaterial();
    const selectionProductType = searchParams.get("selectionProductType");
    const brandIdsStr: string = searchParams.get("brandIds") || "";
    let id = searchParams.get("brandId") || "";

    try {
      const brandIds = brandIdsStr ? decodeURIComponent(brandIdsStr).split(",") : [];

      if (selectionProductType && selectionProductType === "BRAND") {
        if (brandIds.length > 0) {
          id = brandIds[0];
          setBrandId(id);
        }

        queryBrandList({
          brandIds,
          pageId: "H5_MaterialList",
          voConfig: {
            withBrandVideo: false,
            withProduct: false,
            withProductCnt: 0,
          },
        }).then((res: any) => {
          if (res?.result?.length) {
            setBrandList(res?.result);
          }
        });
      }
    } catch (e) {
      console.error(e);
    }

    frontCodes.current = [...(id ? [{ type: 2, code: id }] : []), { type: 7, code: "7" }];

    getMaterialList(true).finally(() => {
      setFirstLoading(false);
      /* eslint-disable */
      if (track.track) {
        track.track("$pageview", {
          page_name: "品牌素材列表页 ",
          previous_page_name: contextTrackData["previous_page_name"] || previous_page_name,
          brand_id: id,
        });
      }
    });
  }, []);

  const onBrand = (item: BrandCardModel) => {
    frontCodes.current = [
      ...(item.brandId ? [{ type: 2, code: item.brandId }] : []),
      { type: 7, code: "7" },
    ];
    if (track.track) {
      track.track("btn_click", {
        page_name: "品牌素材",
        tab_name: item?.brandName || "",
        resource_type: "品牌素材",
        resource_content: "素材",
        btn_name: "品牌点击",
        previous_page_name: contextTrackData["previous_page_name"] || previous_page_name,
      });
    }
    setBrandId(item.brandId);
    getMaterialList(true);
  };

  const onPreviewAction = (item, index) => {
    const mediaList = item?.newCoverVoList || [];
    const sources = mediaList.map(item => {
      const { coverType, coverUrl, vedioUrl } = item;

      if (coverType === 2) {
        // 图片类型
        return {
          content: coverUrl,
          contentType: 2,
        };
      }

      // 视频类型（coverType 为 0 或 1）
      return {
        content: vedioUrl, // ✅ 确保字段名为 videoUrl（非 vedioUrl）
        contentType: 3,
        coverImgUrl: coverUrl,
      };
    });
    setMaterialListNew(sources);
    setPreviewVisible(true);
    setSelectIndex(index);
  };

  return (
    <div className={styles["brand-material"]}>
      <TopBar isShowSearch={false} isHideRight={true} />
      {brandList?.length > 1 && (
        <div className={styles.brandTab}>
          {brandList.map((item, index) => (
            <div
              onClick={() => onBrand(item)}
              key={index}
              className={styles.brandItem + (brandId === item.brandId ? " " + styles.active : "")}>
              <img
                className={styles.brandLogo}
                src={ImageURLUitls.normalProcessImage(item.brandLogo, 50, 50)}
                alt=""
              />
            </div>
          ))}
        </div>
      )}
      <div
        className={
          styles["brand-material-content"] +
          (brandList?.length > 1 ? " " + styles.brandTabShow : "")
        }
        id="material">
        {materialList.length > 0 && (
          <>
            {materialList.map((item, index) => (
              <div className={styles["material-list-item"]} key={index}>
                <MaterialListCardComp
                  material={item}
                  isCollect={true}
                  showlabel={true}
                  getServerTime={getServerTime}
                  onForwardAction={onForwardAction}
                  onAction={toMaterialDetailPage}
                  onAvatarAction={toMaterialDetailPage}
                  onLabelAction={toMaterialDetailPage}
                  onPreviewAction={onPreviewAction}
                />
              </div>
            ))}
            <InfiniteScroll loadMore={loadMore} hasMore={hasMore} threshold={0} />
          </>
        )}
        {!materialList.length && !hasMore && !firstLoading && <Empty label="暂无数据" />}
        {/** 初始加载 */}
        {firstLoading && (
          <div className={styles["loading"]}>
            <img src={loadingPng} />
          </div>
        )}
      </div>
      {isPreviewVisible && (
        <MediaPreview
          mediaList={materialListNew}
          currentIndex={selectIndex}
          onClose={() => setPreviewVisible(false)}
          onChange={index => {
            setSelectIndex(index);
          }}
        />
      )}
      <PosterSwipe
        show={showPoster}
        posterData={sharePosterData}
        customEditData={customEditData}
        shareType="MATERIAL"
        btnConfig={["copy", "edit"]}
        close={onClosePoster}
      />
      <SideBar />
    </div>
  );
};

export default BrandMaterial;
